<section class="bg-anis">
  @let mentions = currentEstimate()?._priceEstimate?.mentions;
  @if (mentions) {
    <div class="centered-with-padding pb-7">
      <div [innerHtml]="mentions" class="text-sm font-medium" handleHtmlLinks></div>
    </div>
  }
</section>
